define.alias("shared/components/shared/post/secondary/activity/action", "settings/components/shared/post/secondary/activity/action");